import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
type ButtonProps = {
  children: React.ReactNode;
  className?: string;
  variant?: 'primary' | 'secondary' | 'outline';
  size?: 'sm' | 'lg';
  arrow?: boolean;
  href?: string;
  target?: '_blank';
  rel?: string;
  onClick?: () => void;
  ariaLabel?: string;
};
export function Button({
  children,
  className = '',
  variant = 'primary',
  size = 'lg',
  arrow = false,
  href,
  target,
  rel,
  onClick,
  ariaLabel
}: ButtonProps) {
  const styles = {
    primary: 'bg-amber-400 text-slate-950 shadow-lg shadow-amber-400/20 ring-1 ring-inset ring-black/10 transition-[background-color,transform] hover:bg-amber-300 active:scale-[0.98]',
    secondary: 'bg-blue-950 text-stone-50 border border-slate-600/40 transition-[background-color,transform] hover:bg-blue-900 active:scale-[0.98]',
    outline: 'border-2 border-amber-400 bg-transparent text-amber-400 transition-colors hover:bg-blue-950'
  };
  const sizes = {
    sm: 'px-6 py-3.5 text-sm',
    lg: 'px-7 py-5 text-base sm:px-12 sm:py-6 sm:text-lg'
  };
  const classes = `inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-xl font-extrabold uppercase tracking-wide duration-150 ease-out focus:outline-none focus-visible:ring-4 focus-visible:ring-amber-400/50 ${styles[variant]} ${sizes[size]} ${className}`;
  if (href) {
    return <a href={href} target={target} rel={rel} onClick={onClick} className={classes} aria-label={ariaLabel} data-id="element-198" data-mp="oq6qlctto60a">
        {children}
        {arrow && <ArrowRightIcon className="h-5 w-5" aria-hidden="true" data-id="element-199" data-mp="xpaagj0tcpfu" />}
      </a>;
  }
  return <button type="button" onClick={onClick} className={classes} aria-label={ariaLabel} data-id="element-200" data-mp="1cd535zetmtsx">
      {children}
      {arrow && <ArrowRightIcon className="h-5 w-5" aria-hidden="true" data-id="element-201" data-mp="17e1yig2r6plh" />}
    </button>;
}